import { render } from "./FifthComponent.vue?vue&type=template&id=3a99e8a0&scoped=true"
import script from "./FifthComponent.vue?vue&type=script&lang=js"
export * from "./FifthComponent.vue?vue&type=script&lang=js"

import "./FifthComponent.vue?vue&type=style&index=0&id=3a99e8a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a99e8a0"]])

export default __exports__